import React, { useEffect, useState } from 'react';

import { SlNavBarPositions, SlNavbarThemes } from '../../../features/shared/public/globalInterfaces/globalInterfaces';
import { SlNavbarState } from '../../../features/navigation/private/global-interface';
import { SlFooter } from '../../../features/navigation/public/SlFooter/SlFooter';
import { SlHelmet } from '../../../features/shared/public/SlHelmet/SlHelmet';
import { SlError } from '../../../features/shared/public/SlError/SlError';
import { setNavigationConfigs } from '../../utils/navigationManager';

const configs = {
	title: 'Oops, 404 Error!',
	info: 'We’re sorry, looks like we can’t find the page you are looking for.',
	imgUrl: 'https://assets.sololearn.com/404.png',
	linkText: 'Go to Homepage',
	linkTo: '/',
	hasBackButton: false,
};

export const PageNotFound = React.memo(() => {
	const [isReady, setIsReady] = useState<boolean>(false);

	useEffect(() => {
		setNavigationConfigs({
			state: SlNavbarState.shown,
			theme: SlNavbarThemes.light,
			position: SlNavBarPositions.relative,
		});
		setIsReady(true);
		return () => {
			setNavigationConfigs({
				state: SlNavbarState.hidden,
			});
		};
	}, []);

	return (
		<>
			<SlHelmet
				title='Sololearn: Learn to Code'
			/>
			{
				isReady
					? (
						<>
							<SlError configs={configs} />
							<SlFooter />
						</>
					)
					: null
			}
		</>
	);
});
